<!--
 * @Description  : 改签乘车人列表
-->
<template>
  <order-common-card title="乘车人">
		<view wx:for="{{list}}" bindtap="checkPassenger(item)" wx:key="index" class="passenger">
			<es-icon
				wx:if="{{!item.__checked}}"
				class="passenger-check"
				size="18"
				name="square"
			/>
			<es-icon
				wx:else
				wx:class="{{ {'passenger-check':true,checked:!disabled} }}"
				size="18"
				name="check-square"
			/>
			<view class="passenger-info">
				<view class="passenger-info-name">{{item.passenger_name}}</view>
				<view class="passenger-info-id">{{item.passenger_id_no}}</view>
			</view>
		</view>
  </order-common-card>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
			passengers: {
				type: Array,
				value: () => ([])
			}
    },
		data() {
			return {
				list: [],
				disabled: false
			}
		},
		ready() {
			this.list = this.passengers?.map(t => ({
				...t,
				__checked: false
			})) || []
			this.list.forEach(item => {
				this.checkPassenger(item)
			})
			this.disabled = true
		},
		methods: {
			checkPassenger(ticket) {
				if(!this.disabled) {
					ticket.__checked = !ticket.__checked
					this.$trigger('check', this.list.filter(t => t.__checked))
				}
			}
		}
  })
</script>
<style scoped lang="stylus">
  @import '~@/mixins/stylus/color.styl'
	
	.passenger
		height 65px
		display flex
		align-items center
		border-bottom 1px solid RGBA(0, 0, 0, 0.04)
		&:last-child
			border none
		&-check
			color $train-color-999
			&.checked
				color $train-color-theme-blue
		&-info
			margin-left 13px
			letter-spacing 0px
			font-weight normal
			&-name
				font-family PingFangSC-Medium
				font-size 15px
				line-height 18px
				color #333333
			&-id
				font-family PingFangSC-Regular
				font-size 13px
				line-height 16px
				color #999999
				margin-top 5px
</style>
<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'order-common-card': '@/components/order-common-card',
      'es-icon': '@didi/es-mpx-ui/lib/icon'
    }
  }
</script>